import { NumberInput } from 'components/NumberInput/NumberInput'
import { translate } from 'i18n/i18n'

const ColorBar = ({ color }: { color: string }) => (
  <div
    css={{
      width: '30px',
      height: '3px',
      backgroundColor: color,
    }}
  />
)

const Label = ({ label }: { label?: string }) => (
  <span
    css={{
      fontSize: '14px',
      fontWeight: 'bold',
      minWidth: '35px',
    }}
  >
    {label}
  </span>
)

const Input = ({
  value,
  onChange,
}: {
  value: number | ''
  onChange: (value: number | '') => void
  precision?: number
}) => {
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '6px',
        padding: '6px 8px',
      }}
    >
      <NumberInput precision={4} w={100} value={value ?? ''} onChange={onChange} max={100} min={0} />
      <span css={{ marginLeft: '4px' }}>{translate.phrases.unitSymbols('%')}</span>
    </div>
  )
}

export const PwpFcNumberInput = ({
  label,
  value,
  setValue,
  color,
}: {
  label?: string
  value: number | ''
  setValue: (value: number | '') => void
  color: string
}) => {
  return (
    <div css={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <ColorBar color={color} />
      <Label label={label} />
      <Input value={value} onChange={setValue} />
    </div>
  )
}
